import {
  faCheckCircle,
  faClock,
  faInfoCircle,
  faTimesCircle,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons'

export class Message {
  static readonly Good: number = 1
  static readonly Pending: number = 2
  static readonly Neutral: number = 3
  static readonly Bad: number = 4

  static readonly Small: number = 1
  static readonly Medium: number = 2
  static readonly Large: number = 3

  public position = 0
  public animationStatus = 'hidden'
  public visible = true

  constructor(
    public readonly id: string,
    public readonly title: string,
    public readonly description: string,
    public readonly status: number,
    public readonly size: number = Message.Small
  ) {}

  public get statusColour(): string {
    switch (this.status) {
      case Message.Good:
        return 'green'
      case Message.Pending:
        return 'yellow'
      case Message.Neutral:
        return 'blue'
      case Message.Bad:
      default:
        return 'red'
    }
  }

  public get icon(): IconDefinition {
    switch (this.status) {
      case Message.Good:
        return faCheckCircle
      case Message.Pending:
        return faClock
      case Message.Neutral:
        return faInfoCircle
      case Message.Bad:
      default:
        return faTimesCircle
    }
  }

  public get sizeNumber(): number {
    switch (this.size) {
      case Message.Small:
        return 60
      case Message.Medium:
        return 80
      case Message.Large:
      default:
        return 100
    }
  }
}
